// (function () {
//   "use strict";

//   class BundlePicker {
//     constructor(el) {
//       this.el = el;
//       this.cards = el.querySelectorAll(".bundle-picker__card");
//       this.singleCard = el.querySelector('[data-bundle-type="single"]');
//       this.bundleCard = el.querySelector('[data-bundle-type="bundle"]');

//       this.singleQty = parseInt(el.dataset.singleQty, 10) || 1;

//       this.form =
//         el.closest('form[action$="/cart/add"]') ||
//         document.querySelector('form[action$="/cart/add"]');
//       this.qtyInput = this._findQtyInput();

//       this.bundleTitleEl = el.querySelector("[data-bundle-title]");
//       this.bundleHeaderTitleEl = el.querySelector("[data-bundle-header-title]");
//       this.bundleSubtitleEl = el.querySelector("[data-bundle-subtitle]");
//       this.bundleSaveEl = el.querySelector("[data-bundle-save]");
//       this.singlePriceEl = el.querySelector(".bundle-picker__price--single");
//       this.bundlePriceEl = el.querySelector(".bundle-picker__price--bundle");
//       this.unitPriceEl = el.querySelector(
//         ".bundle-picker__product-price--unit",
//       );
//       this.discountedUnitPriceEl = el.querySelector(
//         ".bundle-picker__product-price--discounted",
//       );
//       this.origPriceEl = el.querySelector(
//         ".bundle-picker__product-price--original",
//       );
//       this.singleTitleEl = el.querySelector("[data-single-title]");
//       this.subtitleEl = el.querySelector("[data-single-subtitle]");
//       this.paidQtyEl = el.querySelector("[data-paid-qty]");
//       this.freeQtyEl = el.querySelector("[data-free-qty]");
//       this.paidTitleEl = el.querySelector("[data-paid-title]");
//       this.freeTitleEl = el.querySelector("[data-free-title]");
//       this.chipImageEls = el.querySelectorAll("[data-bundle-chip-image]");
//       this.defaultImageSrc = this.chipImageEls[0]?.getAttribute("src") || "";
//       this.defaultImageAlt =
//         this.chipImageEls[0]?.getAttribute("alt") || this._productTitle();
//       this.plusEl = el.querySelector(".bundle-picker__plus");
//       this.freeChipEl = el.querySelector(".bundle-picker__product-chip--free");
//       this.perServingEl = el.querySelector("[data-per-serving]");
//       this.perServingTemplate = this.perServingEl?.dataset.template || "";

//       const variantsKey = el.dataset.variantsKey;
//       const promosKey = el.dataset.promosKey;
//       const subtitlesKey = el.dataset.subtitlesKey;
//       const bundleSubtitlesKey = el.dataset.bundleSubtitlesKey;
//       this.variants =
//         (variantsKey && window["__bundlePickerVariants_" + variantsKey]) || [];
//       this.promos =
//         (promosKey && window["__bundlePickerPromos_" + promosKey]) || {};
//       this.singleSubtitles =
//         (subtitlesKey &&
//           window["__bundlePickerSingleSubtitles_" + subtitlesKey]) ||
//         {};
//       this.bundleSubtitles =
//         (bundleSubtitlesKey &&
//           window["__bundlePickerBundleSubtitles_" + bundleSubtitlesKey]) ||
//         {};
//       const weightsKey = el.dataset.weightsKey;
//       this.weights =
//         (weightsKey && window["__bundlePickerWeights_" + weightsKey]) || {};
//       this.moneyFormat = window.__bundlePickerMoneyFormat || "RM{{amount}}";
//       this.currentPromo = null;
//       this.currentSingleTitle = "Sticks";
//       this.currentBundleTitle = "Bundle";

//       this._bindEvents();
//       this._selectCard(this.singleCard);
//       this._startVariantWatcher();
//     }

//     _findQtyInput() {
//       if (!this.form) return null;
//       return (
//         this.form.querySelector('input[name="quantity"]') ||
//         this.form.querySelector(".quantity__input") ||
//         this.form.querySelector("[data-quantity-input]")
//       );
//     }

//     _findMainPriceEl() {
//       const productInfoEl = this.el.closest(".product__info-container");
//       const markedPriceEl = productInfoEl?.querySelector(
//         "[data-bundle-main-price]",
//       );
//       if (markedPriceEl) return markedPriceEl;

//       const sectionId = this.form?.id?.replace(/^product-form-/, "");
//       if (sectionId && sectionId !== this.form?.id) {
//         const priceEl = document.getElementById(`price-${sectionId}`);
//         if (priceEl) return priceEl;
//       }

//       const sectionEl = this.el.closest('[id^="shopify-section-"]');
//       return sectionEl?.querySelector('.price-wrapper[id^="price-"]') || null;
//     }

//     _bindEvents() {
//       this.cards.forEach((card) => {
//         card.addEventListener("click", () => {
//           if (card.hidden) return;
//           this._selectCard(card);
//         });
//         card.addEventListener("keydown", (e) => {
//           if ((e.key === " " || e.key === "Enter") && !card.hidden) {
//             e.preventDefault();
//             this._selectCard(card);
//           }
//         });
//       });

//       document.addEventListener("variant:changed", (e) => {
//         if (e.detail?.variant) this._onVariantChange(e.detail.variant);
//       });
//       this.form?.addEventListener("variant:changed", (e) => {
//         if (e.detail?.variant) this._onVariantChange(e.detail.variant);
//       });

//       this.form
//         ?.querySelector('input[name="id"]')
//         ?.addEventListener("change", (e) => {
//           if (e.target?.value) this._onVariantById(e.target.value);
//         });
//       this.qtyInput?.addEventListener("change", (e) => {
//         this._updateStickyQty(e.target.value);
//         this._syncAtcButtonPrice();
//       });
//       this.qtyInput?.addEventListener("input", (e) => {
//         this._updateStickyQty(e.target.value);
//         this._syncAtcButtonPrice();
//       });
//     }

//     _startVariantWatcher() {
//       const getInput = () => this.form?.querySelector('input[name="id"]');
//       const input = getInput();
//       if (input?.value) this._onVariantById(input.value);

//       let lastId = getInput()?.value || "";
//       setInterval(() => {
//         const current = getInput()?.value || "";
//         if (current && current !== lastId) {
//           lastId = current;
//           this._onVariantById(current);
//         }
//       }, 200);
//     }

//     _onVariantById(variantId) {
//       const variant = this.variants.find(
//         (v) => String(v.id) === String(variantId),
//       );
//       if (variant) this._onVariantChange(variant);
//     }

//     _onVariantChange(variant) {
//       if (!variant) return;
//       this.currentVariant = variant;
//       this.currentPromo = this.promos[String(variant.id)] || null;
//       this._updateVariantImages(variant);
//       this._updateSubtitle(variant);
//       this._applyPromo();
//       this._updatePrices(variant.price);
//       this._queueMainPriceSync(variant.price);
//       this._updatePerServing();
//     }

//     _updateVariantImages(variant) {
//       const imageSrc = this._variantImageSrc(variant) || this.defaultImageSrc;
//       if (!imageSrc) return;

//       const imageAlt = variant.title || this.defaultImageAlt;
//       this.chipImageEls.forEach((img) => {
//         img.src = imageSrc;
//         img.alt = imageAlt;
//       });
//     }

//     _variantImageSrc(variant) {
//       const image = variant?.featured_image;
//       if (!image) return "";
//       if (typeof image === "string") return image;
//       return image.src || image.url || "";
//     }

//     _updateSubtitle(variant) {
//       if (!this.subtitleEl) return;
//       const option = variant.option1 || variant.title || "";
//       const fallbackSubtitle = option;
//       const customText = this.singleSubtitles[String(variant.id)];
//       if (customText) {
//         const lines = this._splitMetafieldLines(customText);
//         this.currentSingleTitle = lines[0] || "Sticks";
//         if (this.singleTitleEl)
//           this.singleTitleEl.textContent = this.currentSingleTitle;
//         this.subtitleEl.textContent =
//           lines.slice(1).join(" ") || fallbackSubtitle;
//         this._updateHeaderTitle();
//         return;
//       }

//       this.currentSingleTitle = "Sticks";
//       if (this.singleTitleEl)
//         this.singleTitleEl.textContent = this.currentSingleTitle;
//       this.subtitleEl.textContent = fallbackSubtitle;
//       this._updateHeaderTitle();
//     }

//     _applyPromo() {
//       if (!this.currentPromo) {
//         if (this.bundleHeaderTitleEl) this.bundleHeaderTitleEl.textContent = "";
//         this.el.hidden = true;
//         this.bundleCard.hidden = true;
//         this._selectCard(this.singleCard);
//         return;
//       }

//       this.el.hidden = false;
//       this.bundleCard.hidden = false;

//       this._updateBundleText();

//       if (this.paidQtyEl)
//         this.paidQtyEl.textContent = `x${this._bundlePaidDisplayQty()}`;
//       if (this.freeQtyEl) this.freeQtyEl.textContent = `x${this._freeQty()}`;

//       const showFree =
//         this._promoType() === "buy_x_free_y" && this._freeQty() > 0;
//       if (this.plusEl) this.plusEl.hidden = !showFree;
//       if (this.freeChipEl) this.freeChipEl.hidden = !showFree;

//       if (this.selectedCard === this.bundleCard) {
//         this._setQty(this._bundleQty());
//       }
//       this._updateProperty(this.selectedCard === this.bundleCard);
//     }

//     _updateBundleText() {
//       const customText = this.bundleSubtitles[String(this.currentVariantId())];
//       const lines = customText ? this._splitMetafieldLines(customText) : [];

//       const bundleTitle = lines[0] || "Bundle";
//       this.currentBundleTitle = bundleTitle;
//       if (this.bundleTitleEl) this.bundleTitleEl.textContent = bundleTitle;
//       this._updateHeaderTitle();

//       const subtitle = lines.slice(1).join(" ");
//       if (this.bundleSubtitleEl) {
//         this.bundleSubtitleEl.textContent = subtitle;
//         this.bundleSubtitleEl.hidden = !subtitle;
//       }
//       if (this.paidTitleEl) this.paidTitleEl.textContent = this._productTitle();
//       if (this.freeTitleEl) this.freeTitleEl.textContent = this._productTitle();
//     }

//     _splitMetafieldLines(value) {
//       return String(value)
//         .replace(/<br\s*\/?>/gi, "\n")
//         .replace(/\\n/g, "\n")
//         .split(/\r?\n|\s+\|\s+/)
//         .map((line) => line.trim())
//         .filter(Boolean);
//     }

//     _selectCard(card) {
//       if (!card) return;
//       this.selectedCard = card;
//       const isBundle = card.dataset.bundleType === "bundle";

//       this.cards.forEach((c) => {
//         const selected = c === card;
//         c.setAttribute("aria-checked", String(selected));
//         c.classList.toggle("bundle-picker__card--selected", selected);
//       });

//       this._setQty(isBundle ? this._bundleQty() : this.singleQty);
//       this._updateProperty(isBundle);
//       this._updateHeaderTitle();
//       this._syncMainPrice();
//       this._queueMainPriceSync();
//       this._updatePerServing();
//     }

//     _currentWeightGrams() {
//       return Number(this.weights[String(this.currentVariantId())]) || 0;
//     }

//     _updatePerServing() {
//       if (!this.perServingEl || !this.perServingTemplate) return;
//       const unitWeight = this._currentWeightGrams();
//       if (!unitWeight || !this.currentVariant?.price) {
//         this.perServingEl.hidden = true;
//         return;
//       }
//       const isBundle =
//         this.selectedCard === this.bundleCard && !!this.currentPromo;
//       const qty = isBundle ? Math.max(this._bundleQty(), 1) : 1;
//       const totalPriceCents = isBundle
//         ? this._selectedMainPriceCents()
//         : this.currentVariant.price;
//       const servings = (unitWeight * qty) / 3;
//       if (!servings) {
//         this.perServingEl.hidden = true;
//         return;
//       }
//       this.perServingEl.textContent = this.perServingTemplate.replace(
//         "[[price]]",
//         this._formatMoney(totalPriceCents / servings),
//       );
//       this.perServingEl.hidden = false;
//     }

//     _updateHeaderTitle() {
//       if (!this.bundleHeaderTitleEl) return;
//       const title =
//         this.selectedCard === this.bundleCard
//           ? this.currentBundleTitle
//           : this.currentSingleTitle;
//       this.bundleHeaderTitleEl.textContent = title ? ` ${title}` : "";
//     }

//     _updateProperty(isBundle) {
//       const propInput = this.form?.querySelector(
//         'input[name="properties[Set]"]',
//       );
//       const setValue =
//         isBundle && this.currentPromo
//           ? this.currentBundleTitle
//           : this.currentSingleTitle;

//       if (propInput) propInput.value = setValue;
//       this._updateStickySet(setValue);
//       this._updateStickySetProperty(setValue);
//     }

//     _updateStickySet(value) {
//       if (!value) return;
//       document.querySelectorAll("[data-sticky-set]").forEach((setEl) => {
//         setEl.textContent = value;
//       });
//     }

//     _updateStickySetProperty(value) {
//       if (!value) return;
//       document
//         .querySelectorAll("[data-sticky-set-property]")
//         .forEach((input) => {
//           input.value = value;
//         });
//     }

//     _setQty(qty) {
//       if (this.qtyInput) {
//         this.qtyInput.value = qty;
//         this.qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
//         this.qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
//       }
//       this._updateStickyQty(qty);
//     }

//     _updateStickyQty(qty) {
//       if (!qty) return;
//       document.querySelectorAll("[data-sticky-quantity]").forEach((input) => {
//         input.value = qty;
//       });
//     }

//     _updatePrices(priceCents) {
//       if (!priceCents) return;

//       if (this.singlePriceEl)
//         this.singlePriceEl.textContent = this._formatMoney(priceCents);

//       if (!this.currentPromo) {
//         this._syncMainPrice(priceCents);
//         return;
//       }

//       const bundlePrice =
//         this._promoType() === "percent"
//           ? this._totalPriceCents()
//           : priceCents * this._buyQty();

//       const unitDisplayPrice =
//         this._promoType() === "percent"
//           ? priceCents * this._bundleQty()
//           : priceCents;

//       if (this.bundlePriceEl)
//         this.bundlePriceEl.textContent = this._formatMoney(bundlePrice);
//       if (this.unitPriceEl) {
//         this.unitPriceEl.textContent = this._formatMoney(unitDisplayPrice);
//         this.unitPriceEl.classList.toggle(
//           "bundle-picker__product-price--original",
//           this._promoType() === "percent",
//         );
//       }
//       if (this.discountedUnitPriceEl) {
//         this.discountedUnitPriceEl.textContent = this._formatMoney(bundlePrice);
//         this.discountedUnitPriceEl.hidden = this._promoType() !== "percent";
//       }
//       if (this.origPriceEl)
//         this.origPriceEl.textContent = this._formatMoney(priceCents);

//       if (this.bundleSaveEl) {
//         const saveLabel = this._saveLabel();
//         this.bundleSaveEl.textContent = saveLabel;
//         this.bundleSaveEl.hidden = !saveLabel;
//       }

//       this._syncMainPrice(priceCents);
//     }

//     _selectedMainPriceCents(priceCents = this.currentVariant?.price) {
//       if (!priceCents) return 0;
//       if (this.selectedCard === this.bundleCard && this.currentPromo) {
//         return this._promoType() === "percent"
//           ? this._totalPriceCents()
//           : priceCents * this._buyQty();
//       }
//       return priceCents;
//     }

//     _setMainPriceText(mainPriceEl, formattedPrice) {
//       if (!mainPriceEl || !formattedPrice) return;

//       mainPriceEl
//         .querySelectorAll(
//           ".price__regular .price-item--regular, .price__sale .price-item--sale",
//         )
//         .forEach((amountEl) => {
//           const innerPriceEl = amountEl.querySelector("span") || amountEl;
//           innerPriceEl.textContent = formattedPrice;
//         });
//     }

//     _setStickyButtonPriceText(formattedPrice) {
//       if (!formattedPrice) return;
//       document.querySelectorAll("[data-sticky-button-price]").forEach((el) => {
//         el.textContent = formattedPrice;
//       });
//     }

//     _atcQty() {
//       const qty = parseInt(this.qtyInput?.value, 10);
//       return qty > 0 ? qty : 1;
//     }

//     // Cart total for what the button would add: whole promo sets are charged at
//     // the set price, any leftover units at the plain unit price. With no promo
//     // selected the set is a single unit, so this reduces to price x quantity.
//     _atcTotalPriceCents(priceCents = this.currentVariant?.price) {
//       const unitPrice = priceCents || 0;
//       if (!unitPrice) return 0;

//       const isBundle =
//         this.selectedCard === this.bundleCard && !!this.currentPromo;
//       const setQty = isBundle ? Math.max(this._bundleQty(), 1) : 1;
//       const setPrice = isBundle
//         ? this._selectedMainPriceCents(unitPrice)
//         : unitPrice;

//       const qty = this._atcQty();
//       const sets = Math.floor(qty / setQty);
//       return sets * setPrice + (qty - sets * setQty) * unitPrice;
//     }

//     _syncAtcButtonPrice(priceCents = this.currentVariant?.price) {
//       const totalCents = this._atcTotalPriceCents(priceCents);
//       if (!totalCents) return;

//       const formattedPrice = this._formatMoneyWithoutTrailingZeros(totalCents);
//       const scope = this.form || document;

//       scope.querySelectorAll("[data-price-template]").forEach((labelEl) => {
//         const template = labelEl.dataset.priceTemplate;
//         if (!template) return;

//         const label = template.replace("[[price]]", () => formattedPrice);
//         // global.js toggleAddButton() restores the label from data-label after
//         // every variant fetch, so keep it in sync or the price snaps back.
//         labelEl.dataset.label = label;
//         // A disabled button reads "Sold out"/"Unavailable" — leave it alone.
//         if (!labelEl.closest("button")?.hasAttribute("disabled")) {
//           labelEl.textContent = label;
//         }
//       });
//     }

//     _queueMainPriceSync(priceCents = this.currentVariant?.price) {
//       window.requestAnimationFrame?.(() => {
//         this._syncMainPrice(priceCents);
//       });

//       window.setTimeout(() => {
//         this._syncMainPrice(priceCents);
//       }, 100);
//     }

//     _selectedCardPriceText() {
//       const priceEl =
//         this.selectedCard === this.bundleCard
//           ? this.bundlePriceEl
//           : this.singlePriceEl;
//       return priceEl?.textContent?.trim() || "";
//     }

//     _syncMainPrice(priceCents = this.currentVariant?.price) {
//       const priceEl = this._findMainPriceEl();
//       const fallbackPrice = this._selectedMainPriceCents(priceCents);
//       const priceText =
//         this._selectedCardPriceText() ||
//         (fallbackPrice ? this._formatMoney(fallbackPrice) : "");

//       this._setMainPriceText(priceEl, priceText);
//       this._setStickyButtonPriceText(priceText);
//       this._syncAtcButtonPrice(priceCents);
//     }

//     _formatMoney(cents) {
//       const amount = cents / 100;
//       return this.moneyFormat
//         .replace("{{amount}}", amount.toFixed(2))
//         .replace("{{amount_no_decimals}}", Math.floor(amount))
//         .replace(
//           "{{amount_with_comma_separator}}",
//           amount.toFixed(2).replace(".", ","),
//         );
//     }

//     // Mirrors Liquid's money_without_trailing_zeros, which renders the button's
//     // initial label — otherwise "RM120" flips to "RM120.00" on first sync.
//     _formatMoneyWithoutTrailingZeros(cents) {
//       return this._formatMoney(cents).replace(/([.,])00(?!\d)/, "");
//     }

//     _formatPercent(value) {
//       const percent = Number(value);
//       if (!Number.isFinite(percent)) return "0";
//       return percent.toFixed(2).replace(/\.?0+$/, "");
//     }

//     _promoType() {
//       const value = String(this.currentPromo?.promoType || "")
//         .trim()
//         .toLowerCase();
//       return value === "percent" ? "percent" : "buy_x_free_y";
//     }

//     _savingsDisplay() {
//       const value = String(this.currentPromo?.savingsDisplay || "")
//         .trim()
//         .toLowerCase();
//       return value === "amount" || value === "rm" ? "amount" : "percent";
//     }

//     currentVariantId() {
//       return this.currentVariant?.id || "";
//     }

//     _productTitle() {
//       return this.el.dataset.productTitle || "";
//     }

//     _buyQty() {
//       return Math.max(parseInt(this.currentPromo?.buyQty, 10) || 1, 1);
//     }

//     _freeQty() {
//       return Math.max(parseInt(this.currentPromo?.freeQty, 10) || 0, 0);
//     }

//     _totalPriceCents() {
//       const value = String(this.currentPromo?.totalPrice ?? "").replace(
//         ",",
//         ".",
//       );
//       return Math.round(Math.max(parseFloat(value) || 0, 0) * 100);
//     }

//     _bundleQty() {
//       return this._promoType() === "percent"
//         ? this._buyQty()
//         : this._buyQty() + this._freeQty();
//     }

//     _bundlePaidDisplayQty() {
//       return this._promoType() === "percent"
//         ? this._bundleQty()
//         : this._buyQty();
//     }

//     _savePct() {
//       if (this._promoType() === "percent") {
//         const originalTotal = this._originalTotalCents();
//         const savings = this._savingsCents();
//         if (!originalTotal || !savings) return 0;
//         return (savings / originalTotal) * 100;
//       }
//       const totalQty = this._bundleQty();
//       if (!totalQty) return 0;
//       return Math.round((this._freeQty() / totalQty) * 100);
//     }

//     _saveLabel() {
//       if (this._savingsDisplay() === "amount") {
//         const savings = this._savingsCents();
//         return savings ? `- Save ${this._formatMoney(savings)}` : "";
//       }

//       const savePct = this._savePct();
//       return savePct ? `- Save ${this._formatPercent(savePct)}%` : "";
//     }

//     _originalTotalCents() {
//       return (this.currentVariant?.price || 0) * this._bundleQty();
//     }

//     _savingsCents() {
//       if (!this.currentVariant?.price) return 0;

//       if (this._promoType() === "percent") {
//         return Math.max(
//           this._originalTotalCents() - this._totalPriceCents(),
//           0,
//         );
//       }

//       return this.currentVariant.price * this._freeQty();
//     }
//   }

//   function init() {
//     document.querySelectorAll(".bundle-picker").forEach((el) => {
//       if (!el._bundlePicker) el._bundlePicker = new BundlePicker(el);
//     });
//   }

//   document.readyState === "loading"
//     ? document.addEventListener("DOMContentLoaded", init)
//     : init();

//   document.addEventListener("shopify:block:select", init);
//   document.addEventListener("shopify:section:load", init);
// })();


(function () {
  "use strict";

  /*
   * CHANGES FROM YOUR ORIGINAL SCRIPT
   * ----------------------------------
   * The old version only understood two cards: `data-bundle-type="single"`
   * and `data-bundle-type="bundle"`. Every bundle-related field was looked
   * up ONCE at the widget level (`el.querySelector(...)`), so duplicating
   * the bundle card for a second tier meant both cards fought over the
   * same element references.
   *
   * This version treats every card that isn't "single" as its own
   * independent "tier" (e.g. "bundle-3x", "bundle-4x", ...). Each tier
   * keeps its own elements (scoped with `card.querySelector`, not
   * `el.querySelector`) and its own promo data, so any number of bundle
   * tiers can coexist and be selected independently.
   *
   * ASSUMPTIONS YOU NEED TO CONFIRM / ADJUST
   * ------------------------------------------
   * 1. Promo data is matched to a card by BUY QUANTITY, not by an arbitrary
   *    tier string. Give each bundle card a `data-bundle-qty="3"` /
   *    `data-bundle-qty="4"` attribute, and key the promo data the same way:
   *      window["__bundlePickerPromos_<key>"] = {
   *        "<variantId>": {
   *          "3": { promoType, buyQty, freeQty, totalPrice, savingsDisplay },
   *          "4": { ... }
   *        }
   *      }
   *    A flat single-promo-per-variant shape (no quantity keys) is still
   *    supported as a fallback, matched to whichever card's `data-bundle-qty`
   *    equals that promo's own `buyQty` — but only ONE card can ever show in
   *    that shape, since there's only one promo object to go around.
   *
   * 2. Per-tier title/subtitle text comes from a variant metafield, same
   *    pattern as your original single-bundle flow — just give each card
   *    its own `data-subtitles-key` so it points at its own flat map:
   *      window["__bundlePickerBundleSubtitles_<key>"] = {
   *        "<variantId>": "Title\nSubtitle"
   *      }
   *    A card with no `data-subtitles-key` falls back to the widget-level
   *    legacy map (`data-bundle-subtitles-key` on the widget root), so your
   *    existing 4x card needs no changes.
   *
   * 3. The members' add-on (checkbox + "Sticks box + Shaker") only had
   *    markup, no behavior. This script now: shows/hides the addon panel
   *    based on which tier is selected, and folds the addon's price into
   *    the running total when checked (via a `data-addon-price-cents`
   *    attribute you add to the checkbox — see the updated 3x card below).
   *    It does NOT yet add the sticks/shaker as separate cart line items —
   *    a standard `/cart/add` form can only submit one variant, so that
   *    needs a Cart AJAX (`/cart/add.js`) call with the sticks + shaker
   *    variant IDs. Send those variant IDs over and I'll wire that part in.
   */

  class BundlePicker {
    constructor(el) {
      this.el = el;
      this.cards = Array.from(el.querySelectorAll(".bundle-picker__card"));
      this.singleCard = el.querySelector('[data-bundle-type="single"]');
      this.singleQty = parseInt(el.dataset.singleQty, 10) || 1;

      this.form =
        el.closest('form[action$="/cart/add"]') ||
        document.querySelector('form[action$="/cart/add"]');
      this.qtyInput = this._findQtyInput();

      // Elements that only ever belong to the single card.
      this.singlePriceEl = el.querySelector(".bundle-picker__price--single");
      this.singleTitleEl = el.querySelector("[data-single-title]");
      this.subtitleEl = el.querySelector("[data-single-subtitle]");

      // Shared header title — reflects whichever card is selected.
      this.bundleHeaderTitleEl = el.querySelector("[data-bundle-header-title]");
      this.perServingEl = el.querySelector("[data-per-serving]");
      this.perServingTemplate = this.perServingEl?.dataset.template || "";
      this.chipImageEls = el.querySelectorAll("[data-bundle-chip-image]");
      this.defaultImageSrc = this.chipImageEls[0]?.getAttribute("src") || "";
      this.defaultImageAlt =
        this.chipImageEls[0]?.getAttribute("alt") || this._productTitle();

      // Every non-"single" card becomes its own bundle tier.
      this.bundleTiers = this.cards
        .filter((card) => card !== this.singleCard)
        .map((card) => this._buildTier(card));

      this.currentSingleTitle = "Sticks";
      this.selectedCard = null;
      this.selectedTier = null;

      const variantsKey = el.dataset.variantsKey;
      const promosKey = el.dataset.promosKey;
      const subtitlesKey = el.dataset.subtitlesKey;
      const bundleSubtitlesKey = el.dataset.bundleSubtitlesKey;
      const weightsKey = el.dataset.weightsKey;

      this.variants =
        (variantsKey && window["__bundlePickerVariants_" + variantsKey]) || [];
      this.promos =
        (promosKey && window["__bundlePickerPromos_" + promosKey]) || {};
      this.singleSubtitles =
        (subtitlesKey &&
          window["__bundlePickerSingleSubtitles_" + subtitlesKey]) ||
        {};
      this.bundleSubtitles =
        (bundleSubtitlesKey &&
          window["__bundlePickerBundleSubtitles_" + bundleSubtitlesKey]) ||
        {};
      this.weights =
        (weightsKey && window["__bundlePickerWeights_" + weightsKey]) || {};
      this.moneyFormat = window.__bundlePickerMoneyFormat || "RM{{amount}}";

      this._bindEvents();
      this._selectCard(this.singleCard);
      this._startVariantWatcher();
    }

    _buildTier(card) {
      return {
        card,
        key: card.dataset.bundleType,
        qty: parseInt(card.dataset.bundleQty, 10) || null,
        title:
          card.querySelector("[data-bundle-title]")?.textContent?.trim() ||
          "Bundle",
        titleEl: card.querySelector("[data-bundle-title]"),
        subtitleEl: card.querySelector("[data-bundle-subtitle]"),
        saveEl: card.querySelector("[data-bundle-save]"),
        priceEl:
          card.querySelector("[data-bundle-price]") ||
          card.querySelector(".bundle-picker__price--bundle"),
        paidQtyEl: card.querySelector("[data-paid-qty]"),
        freeQtyEl: card.querySelector("[data-free-qty]"),
        paidTitleEl: card.querySelector("[data-paid-title]"),
        freeTitleEl: card.querySelector("[data-free-title]"),
        plusEl: card.querySelector(".bundle-picker__plus"),
        freeChipEl: card.querySelector(".bundle-picker__product-chip--free"),
        // Each card has its own mini price row inside its product chip(s) —
        // these are NOT shared across tiers.
        unitPriceEl: card.querySelector(".bundle-picker__product-price--unit"),
        discountedUnitPriceEl: card.querySelector(
          ".bundle-picker__product-price--discounted",
        ),
        origPriceEl: card.querySelector(
          ".bundle-picker__product-price--original",
        ),
        addonEl: card.querySelector("[data-bundle-addon]"),
        addonCheckbox: card.querySelector("[data-addon-checkbox]"),
        // Each card can declare its own per-variant subtitle/title source,
        // e.g. data-subtitles-key="3x" on the card ->
        //   window["__bundlePickerBundleSubtitles_3x"] = { "<variantId>": "Title\nSubtitle" }
        // Cards without their own key fall back to the widget-level legacy
        // map (this.bundleSubtitles) so existing 4x markup keeps working
        // unchanged.
        subtitles: card.dataset.subtitlesKey
          ? window["__bundlePickerBundleSubtitles_" + card.dataset.subtitlesKey] ||
            {}
          : null,
        // A variant-metafield-driven list of add-on products, keyed by
        // variant id: window["__bundlePickerAddonProducts_<key>"] =
        //   { "<variantId>": [{ title, variantTitle, price, image }, ...] }
        addonProductsEl: card.querySelector(".bundle-picker__addon-products"),
        addonProducts: card.dataset.addonProductsKey
          ? window[
              "__bundlePickerAddonProducts_" + card.dataset.addonProductsKey
            ] || {}
          : null,
        // Add-on summary (label + bundled price), keyed by variant:
        //   window["__bundlePickerAddonMeta_<key>"] =
        //     { "<variantId>": { label, priceCents } }
        addonLabelEl: card.querySelector("[data-addon-label]"),
        addonCurrentPriceEl: card.querySelector("[data-addon-current-price]"),
        addonOldPriceEl: card.querySelector("[data-addon-old-price]"),
        addonMeta: card.dataset.addonMetaKey
          ? window["__bundlePickerAddonMeta_" + card.dataset.addonMetaKey] ||
            {}
          : null,
        promo: null,
      };
    }


    _findQtyInput() {
      if (!this.form) return null;
      return (
        this.form.querySelector('input[name="quantity"]') ||
        this.form.querySelector(".quantity__input") ||
        this.form.querySelector("[data-quantity-input]")
      );
    }

    _findMainPriceEl() {
      const productInfoEl = this.el.closest(".product__info-container");
      const markedPriceEl = productInfoEl?.querySelector(
        "[data-bundle-main-price]",
      );
      if (markedPriceEl) return markedPriceEl;

      const sectionId = this.form?.id?.replace(/^product-form-/, "");
      if (sectionId && sectionId !== this.form?.id) {
        const priceEl = document.getElementById(`price-${sectionId}`);
        if (priceEl) return priceEl;
      }

      const sectionEl = this.el.closest('[id^="shopify-section-"]');
      return sectionEl?.querySelector('.price-wrapper[id^="price-"]') || null;
    }

    _bindEvents() {
      this.cards.forEach((card) => {
        card.addEventListener("click", () => {
          if (card.hidden) return;
          this._selectCard(card);
        });
        card.addEventListener("keydown", (e) => {
          if ((e.key === " " || e.key === "Enter") && !card.hidden) {
            e.preventDefault();
            this._selectCard(card);
          }
        });
      });

      this.bundleTiers.forEach((tier) => {
        tier.addonCheckbox?.addEventListener("change", () => {
          this._updateProperty();
          this._syncMainPrice();
          this._updateAddonBreakdown();
        });
      });

      document.addEventListener("variant:changed", (e) => {
        if (e.detail?.variant) this._onVariantChange(e.detail.variant);
      });
      this.form?.addEventListener("variant:changed", (e) => {
        if (e.detail?.variant) this._onVariantChange(e.detail.variant);
      });

      this.form
        ?.querySelector('input[name="id"]')
        ?.addEventListener("change", (e) => {
          if (e.target?.value) this._onVariantById(e.target.value);
        });
      this.qtyInput?.addEventListener("change", (e) => {
        this._updateStickyQty(e.target.value);
        this._syncAtcButtonPrice();
      });
      this.qtyInput?.addEventListener("input", (e) => {
        this._updateStickyQty(e.target.value);
        this._syncAtcButtonPrice();
      });

       document.addEventListener("product-form:collect-items", (e) => {
        const formEl = e.detail?.form;
        if (!formEl) return;

        // Match this picker's form (or any form inside the same product info block)
        const scope = this.el.closest(".product__info-container");
        const sameForm =
          formEl === this.form || (scope && scope.contains(formEl));
        if (!sameForm) return;

        const addonItems = this._addonLineItems(this.selectedTier);
        if (addonItems.length) e.detail.items.push(...addonItems);
      });
    }
    connectedCallback() {
  this._collectItems = (e) => {
    if (e.detail.form !== this.form) return;
    e.detail.items.push(...this._addonLineItems(this.selectedTier));
  };
  document.addEventListener("product-form:collect-items", this._collectItems);
}

disconnectedCallback() {
  document.removeEventListener("product-form:collect-items", this._collectItems);
}

    _startVariantWatcher() {
      const getInput = () => this.form?.querySelector('input[name="id"]');
      const input = getInput();
      if (input?.value) this._onVariantById(input.value);

      let lastId = getInput()?.value || "";
      setInterval(() => {
        const current = getInput()?.value || "";
        if (current && current !== lastId) {
          lastId = current;
          this._onVariantById(current);
        }
      }, 200);
    }

    _onVariantById(variantId) {
      const variant = this.variants.find(
        (v) => String(v.id) === String(variantId),
      );
      if (variant) this._onVariantChange(variant);
    }

    _onVariantChange(variant) {
      if (!variant) return;
      this.currentVariant = variant;
      this._updateVariantImages(variant);
      this._updateSubtitle(variant);
      this._applyPromos();
      this._updatePrices(variant.price);
      this._queueMainPriceSync(variant.price);
      this._updatePerServing();
      this.bundleTiers.forEach((tier) => {
        this._renderAddonProducts(tier);
        this._renderAddonMeta(tier);
      });
      this._updateAddonVisibility();
      this._updateAddonBreakdown(); 
    }

    _updateVariantImages(variant) {
      const imageSrc = this._variantImageSrc(variant) || this.defaultImageSrc;
      if (!imageSrc) return;

      const imageAlt = variant.title || this.defaultImageAlt;
      this.chipImageEls.forEach((img) => {
        img.src = imageSrc;
        img.alt = imageAlt;
      });
    }

    _variantImageSrc(variant) {
      const image = variant?.featured_image;
      if (!image) return "";
      if (typeof image === "string") return image;
      return image.src || image.url || "";
    }

    _updateSubtitle(variant) {
      if (!this.subtitleEl) return;
      const option = variant.option1 || variant.title || "";
      const fallbackSubtitle = option;
      const customText = this.singleSubtitles[String(variant.id)];
      if (customText) {
        const lines = this._splitMetafieldLines(customText);
        this.currentSingleTitle = lines[0] || "Sticks";
        if (this.singleTitleEl)
          this.singleTitleEl.textContent = this.currentSingleTitle;
        this.subtitleEl.textContent =
          lines.slice(1).join(" ") || fallbackSubtitle;
        this._updateHeaderTitle();
        return;
      }

      this.currentSingleTitle = "Sticks";
      if (this.singleTitleEl)
        this.singleTitleEl.textContent = this.currentSingleTitle;
      this.subtitleEl.textContent = fallbackSubtitle;
      this._updateHeaderTitle();
    }

    // Resolves and stores the current variant's promo for every tier, then
    // shows/hides each tier's card individually. The whole widget is only
    // hidden if NONE of the tiers have a promo for this variant.
    _applyPromos() {
  let anyPromoAvailable = false;

  this.bundleTiers.forEach((tier) => {
    const promo = this._promoForTier(tier);
    const hasAddon = this._tierHasRequiredAddonProducts(tier);
    const isEligible = !!promo && hasAddon;

    tier.promo = promo;
    tier.card.hidden = !isEligible;
    if (isEligible) {
      anyPromoAvailable = true;
      this._renderTier(tier);
    }
  });

  this.el.hidden = !anyPromoAvailable;

  if (this.selectedTier && !this._tierHasRequiredAddonProducts(this.selectedTier)) {
    this._selectCard(this.singleCard);
    return;
  }
  if (this.selectedTier && !this.selectedTier.promo) {
    this._selectCard(this.singleCard);
    return;
  }

  if (!anyPromoAvailable) {
    this._selectCard(this.singleCard);
  }
}
   _promoForTier(tier) {
  const variantId = this.currentVariantId();
  const variantPromos = this.promos[String(variantId)];
  if (!variantPromos) return null;

  // New: search all promos for this variant and match by TOTAL bundle
  // quantity (buyQty + freeQty for buy_x_free_y, buyQty alone for percent),
  // not by the raw buy_quantity key.
  const candidates = Object.values(variantPromos).filter(
    (p) => p && typeof p === "object" && "promoType" in p,
  );

  if (candidates.length && tier.qty) {
    const match = candidates.find((p) => this._bundleQty(p) === tier.qty);
    if (match) return match;
  }

  // NOTE: the old exact-key fallback (`variantPromos[String(tier.qty)]`)
  // was removed — it matched by raw `buy_quantity`, not total bundle
  // quantity, which silently handed a buy-3-free-1 promo (buy_quantity: 3)
  // to a tier.qty === 3 card even though that promo's real total is 4.
  // The total-based search above is now the only "nested shape" matcher;
  // only the genuinely flat/legacy single-promo shape falls through below.
  if (variantPromos.promoType) {
    if (!tier.qty) return variantPromos;
    if (Number(variantPromos.buyQty) === Number(tier.qty)) {
      return variantPromos;
    }
  }

  return null;
}

    _renderTier(tier) {
      const unitPrice = this.currentVariant?.price || 0;
      const promo = tier.promo;
      if (!promo) return;

      this._updateTierText(tier);

      const bundlePrice = this._tierBundlePriceCents(tier, unitPrice);
      if (tier.priceEl) tier.priceEl.textContent = this._formatMoney(bundlePrice);

      if (tier.saveEl) {
        const label = this._saveLabel(promo, unitPrice);
        if (label) {
          tier.saveEl.textContent = label;
          tier.saveEl.hidden = false;
        } else {
          tier.saveEl.hidden = true;
        }
      }

      if (tier.paidQtyEl)
        tier.paidQtyEl.textContent = `x${this._bundlePaidDisplayQty(promo)}`;
      if (tier.freeQtyEl)
        tier.freeQtyEl.textContent = `x${this._freeQty(promo)}`;

      const unitDisplayPrice = this._tierUnitDisplayPriceCents(tier, unitPrice);
      if (tier.unitPriceEl) {
        tier.unitPriceEl.textContent = this._formatMoney(unitDisplayPrice);
        tier.unitPriceEl.classList.toggle(
          "bundle-picker__product-price--original",
          this._promoType(promo) === "percent",
        );
      }
      if (tier.discountedUnitPriceEl) {
        tier.discountedUnitPriceEl.textContent = this._formatMoney(bundlePrice);
        tier.discountedUnitPriceEl.hidden = this._promoType(promo) !== "percent";
      }
      if (tier.origPriceEl)
        tier.origPriceEl.textContent = this._formatMoney(unitPrice);

      const showFree =
        this._promoType(promo) === "buy_x_free_y" && this._freeQty(promo) > 0;
      if (tier.plusEl) tier.plusEl.hidden = !showFree;
      if (tier.freeChipEl) tier.freeChipEl.hidden = !showFree;

      if (this.selectedTier === tier) {
        this._setQty(this._bundleQty(promo));
      }
    }

    // Overwrites title/subtitle from a per-variant metafield map, exactly
    // like the original single-bundle flow did — just scoped to whichever
    // map this tier points at (its own data-subtitles-key, or the
    // widget-level legacy map if it doesn't have one).
    _updateTierText(tier) {
      const variantId = this.currentVariantId();
      const subtitles = tier.subtitles || this.bundleSubtitles;
      const customText = subtitles?.[String(variantId)];
      // Defend against a misrouted or wrong-type metafield (rich text,
      // a reference, a list) coming through as an object/array instead of
      // plain text — better to keep the static default than print
      // "[object Object]".
      if (!customText || typeof customText !== "string") return;

      const lines = this._splitMetafieldLines(customText);
      const title = lines[0];
      if (title) {
        tier.title = title;
        if (tier.titleEl) tier.titleEl.textContent = title;
      }

      const subtitle = lines.slice(1).join(" ");
      if (tier.subtitleEl) {
        tier.subtitleEl.textContent = subtitle;
        tier.subtitleEl.hidden = !subtitle;
      }
      if (tier.paidTitleEl) tier.paidTitleEl.textContent = this._productTitle();
      if (tier.freeTitleEl) tier.freeTitleEl.textContent = this._productTitle();

      this._updateHeaderTitle();
    }

    _splitMetafieldLines(value) {
      return String(value)
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/\\n/g, "\n")
        .split(/\r?\n|\s+\|\s+/)
        .map((line) => line.trim())
        .filter(Boolean);
    }

    // Rebuilds a tier's add-on product chips from its variant-metafield
    // data. Runs on every variant change (not gated by promo state) since
    // the metafield is per-variant, independent of pricing.
    _renderAddonProducts(tier) {
      if (!tier.addonProductsEl || !tier.addonProducts) return;
      const items = tier.addonProducts[String(this.currentVariantId())];
      if (!items) return; // no data for this variant — leave existing markup

      tier.addonProductsEl.textContent = "";
      items.forEach((item) => {
        const wrap = document.createElement("div");
        wrap.className = "bundle-picker__addon-product";

        const img = document.createElement("img");
        img.src = item.image || "";
        img.alt = item.title || "";
        img.width = 40;
        img.height = 40;
        img.loading = "lazy";
        wrap.appendChild(img);

        const info = document.createElement("div");
        const titleEl = document.createElement("p");
        titleEl.textContent = item.title || "";
        info.appendChild(titleEl);

        const small = document.createElement("small");
        small.textContent = item.price
          ? [item.variantTitle, this._formatMoney(item.price)]
              .filter(Boolean)
              .join(" · ")
          : "Free with add-on";
        info.appendChild(small);

        wrap.appendChild(info);
        tier.addonProductsEl.appendChild(wrap);
      });
    }

    // Fills in the add-on's label and price from its own metafield data,
    // and derives the struck-through "original" price from the sum of the
    // individual add-on items (so that number never has to be typed twice).
    _renderAddonMeta(tier) {
      if (!tier.addonMeta) return;
      const variantId = String(this.currentVariantId());
      const meta = tier.addonMeta[variantId];

      if (tier.addonLabelEl) {
        const hasLabel = !!(meta && typeof meta.label === "string" && meta.label);
        if (hasLabel) tier.addonLabelEl.textContent = meta.label;
        tier.addonLabelEl.hidden = !hasLabel;
      }

      // The real, discounted add-on price drives both the on-screen text
      // and the checkbox's own data-addon-price-cents, so the displayed
      // price and the amount actually added to the cart can never drift
      // apart.
      const hasPrice = !!(
        meta &&
        typeof meta.priceCents === "number" &&
        meta.priceCents > 0
      );
      if (hasPrice && tier.addonCheckbox) {
        tier.addonCheckbox.dataset.addonPriceCents = String(meta.priceCents);
      }
      if (tier.addonCurrentPriceEl) {
        if (hasPrice) {
          tier.addonCurrentPriceEl.textContent = this._formatMoney(
            meta.priceCents,
          );
        }
        tier.addonCurrentPriceEl.hidden = !hasPrice;
      }

      // Prefer an explicit old-price metafield; fall back to the sum of
      // the individual add-on items' own prices if that isn't set.
      let originalTotalCents =
        meta && typeof meta.oldPriceCents === "number" && meta.oldPriceCents > 0
          ? meta.oldPriceCents
          : 0;
      if (!originalTotalCents) {
        const items = tier.addonProducts?.[variantId];
        originalTotalCents = items?.length
          ? items.reduce((sum, item) => sum + (item.price || 0), 0)
          : 0;
      }
      if (tier.addonOldPriceEl) {
        if (originalTotalCents > 0) {
          tier.addonOldPriceEl.textContent =
            this._formatMoney(originalTotalCents);
        }
        tier.addonOldPriceEl.hidden = !(originalTotalCents > 0);
      }
    }

    _updateAddonVisibility() {
  this.bundleTiers.forEach((tier) => {
    if (!tier.addonEl) return;
    const isSelected = tier === this.selectedTier;
    const items = tier.addonProducts
      ? tier.addonProducts[String(this.currentVariantId())]
      : null;
      console.log("tier.addonProducts",tier.addonProducts)
    const hasAddonProducts = tier.addonProducts
      ? Array.isArray(items) && items.length > 0
      : true; // tiers with no addon-products key aren't gated by this
    tier.addonEl.hidden = !(hasAddonProducts);
  });
}
_addonLineItems(tier) {
  if (!tier?.addonCheckbox?.checked || !tier.addonProducts) return [];
  const items = tier.addonProducts[String(this.currentVariantId())] || [];
  return items
    .filter((item) => item.id)
    .map((item) => ({
      id: item.id,
      quantity: item.quantity || 1,
      properties: { "Set": `${tier.title} add-on` },
    }));
}

// async _addBundleWithAddon(e) {
//   const addonItems = this._addonLineItems(this.selectedTier);
//   if (!addonItems.length) return; // nothing extra to add — let native submit proceed

//   e.preventDefault();

//   const mainId = this.form.querySelector('input[name="id"]')?.value;
//   const mainQty = this._atcQty();
//   const mainProps = {};
//   this.form
//     .querySelectorAll('input[name^="properties["]')
//     .forEach((input) => {
//       const key = input.name.match(/properties\[(.+)\]/)?.[1];
//       if (key) mainProps[key] = input.value;
//     });

//   const items = [
//     { id: mainId, quantity: mainQty, properties: mainProps },
//     ...addonItems,
//   ];

//   const submitBtn = this.form.querySelector('[type="submit"]');
//   submitBtn?.setAttribute("disabled", "disabled");

//   try {
//     const res = await fetch(window.Shopify?.routes?.root
//       ? `${window.Shopify.routes.root}cart/add.js`
//       : "/cart/add.js", {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ items }),
//     });

//     if (!res.ok) {
//       const err = await res.json().catch(() => null);
//       throw new Error(err?.description || "Failed to add to cart");
//     }

//     document.dispatchEvent(
//       new CustomEvent("cart:updated", { bubbles: true }),
//     );
//     document.documentElement.dispatchEvent(
//       new CustomEvent("cart:refresh", { bubbles: true }),
//     );

//     // if (typeof window.location !== "undefined") {
//     //   // Adjust to whatever your theme uses to open the cart drawer —
//     //   // this is a safe fallback if no drawer JS is listening.
//     //   window.location.href = "/cart";
//     // }
//   } catch (err) {
//     console.error("Bundle add-to-cart failed:", err);
//     alert("Sorry, something went wrong adding your bundle to cart.");
//   } finally {
//     submitBtn?.removeAttribute("disabled");
//   }
// }
async _addBundleWithAddon(e) {
  const addonItems = this._addonLineItems(this.selectedTier);
  if (!addonItems.length) return; // let the theme handle it normally

  e.preventDefault();
  e.stopImmediatePropagation(); // stops the theme's handler from also adding

  if (this._adding) return; // guard against double clicks / double fires
  this._adding = true;

  const mainId = this.form.querySelector('[name="id"]')?.value;
  const mainQty = this._atcQty();
  const mainProps = {};
  this.form.querySelectorAll('input[name^="properties["]').forEach((input) => {
    const key = input.name.match(/properties\[(.+)\]/)?.[1];
    if (key) mainProps[key] = input.value;
  });

  const items = [
    { id: Number(mainId), quantity: mainQty, properties: mainProps },
    ...addonItems,
  ];

  const submitBtn = this.form.querySelector('[type="submit"]');
  submitBtn?.setAttribute("disabled", "disabled");

  try {
    const root = window.Shopify?.routes?.root || "/";
    const res = await fetch(`${root}cart/add.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => null);
      throw new Error(err?.description || "Failed to add to cart");
    }

    document.dispatchEvent(new CustomEvent("cart:updated", { bubbles: true }));
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  } catch (err) {
    console.error("Bundle add-to-cart failed:", err);
    alert("Sorry, something went wrong adding your bundle to cart.");
  } finally {
    this._adding = false;
    submitBtn?.removeAttribute("disabled");
  }
}
_updateAddonBreakdown() {
  const el = this.el.querySelector("[data-addon-breakdown]");
  if (!el) return;

  const tier = this.selectedTier;
  if (!tier?.promo || !tier.addonCheckbox?.checked) {
    el.hidden = true;
    return;
  }

  const unitPrice = this.currentVariant?.price;
  const bundlePrice = this._tierBundlePriceCents(tier, unitPrice);
  const addonPrice = this._addonPriceCents(tier);

  el.textContent = `${tier.title} ${this._formatMoneyWithoutTrailingZeros(
    bundlePrice,
  )} + add-on ${this._formatMoneyWithoutTrailingZeros(addonPrice)}`;
  el.hidden = false;
}

    _selectCard(card) {
      if (!card) return;
      this.selectedCard = card;
      this.selectedTier =
        this.bundleTiers.find((t) => t.card === card) || null;
      const isBundle = !!this.selectedTier;

      this.cards.forEach((c) => {
        const selected = c === card;
        c.setAttribute("aria-checked", String(selected));
        c.classList.toggle("bundle-picker__card--selected", selected);
      });

      // Only the selected tier's add-on panel (if it has one) is shown.
      // this.bundleTiers.forEach((t) => {
      //   if (t.addonEl) t.addonEl.hidden = t !== this.selectedTier;
      // });
      this._updateAddonVisibility();

      const qty = isBundle
        ? Math.max(this._bundleQty(this.selectedTier.promo), 1)
        : this.singleQty;
      this._setQty(qty);
      this._updateProperty();
      this._updateHeaderTitle();
      this._syncMainPrice();
      this._queueMainPriceSync();
      this._updatePerServing();
    }

    _currentWeightGrams() {
      return Number(this.weights[String(this.currentVariantId())]) || 0;
    }

    _updatePerServing() {
      if (!this.perServingEl || !this.perServingTemplate) return;
      const unitWeight = this._currentWeightGrams();
      if (!unitWeight || !this.currentVariant?.price) {
        this.perServingEl.hidden = true;
        return;
      }
      const promo = this.selectedTier?.promo;
      const qty = promo ? Math.max(this._bundleQty(promo), 1) : 1;
      const totalPriceCents = promo
        ? this._selectedMainPriceCents()
        : this.currentVariant.price;
      const servings = (unitWeight * qty) / 3;
      if (!servings) {
        this.perServingEl.hidden = true;
        return;
      }
      this.perServingEl.textContent = this.perServingTemplate.replace(
        "[[price]]",
        this._formatMoney(totalPriceCents / servings),
      );
      this.perServingEl.hidden = false;
    }

    _updateHeaderTitle() {
      if (!this.bundleHeaderTitleEl) return;
      const title = this.selectedTier
        ? this.selectedTier.title
        : this.currentSingleTitle;
      this.bundleHeaderTitleEl.textContent = title ? ` ${title}` : "";
    }

    _updateProperty() {
      const propInput = this.form?.querySelector(
        'input[name="properties[Set]"]',
      );
      const setValue = this.selectedTier
        ? this.selectedTier.title
        : this.currentSingleTitle;

      if (propInput) propInput.value = setValue;
      this._updateStickySet(setValue);
      this._updateStickySetProperty(setValue);

      // Optional: add <input type="hidden" name="properties[Addon]"> to the
      // form if you want the add-on choice recorded on the line item.
      const addonPropInput = this.form?.querySelector(
        'input[name="properties[Addon]"]',
      );
      if (addonPropInput) {
        addonPropInput.value = this.selectedTier?.addonCheckbox?.checked
          ? "Sticks box + Shaker"
          : "";
      }
    }

    _updateStickySet(value) {
      if (!value) return;
      document.querySelectorAll("[data-sticky-set]").forEach((setEl) => {
        setEl.textContent = value;
      });
    }

    _updateStickySetProperty(value) {
      if (!value) return;
      document
        .querySelectorAll("[data-sticky-set-property]")
        .forEach((input) => {
          input.value = value;
        });
    }

    _setQty(qty) {
      if (this.qtyInput) {
        this.qtyInput.value = qty;
        this.qtyInput.dispatchEvent(new Event("change", { bubbles: true }));
        this.qtyInput.dispatchEvent(new Event("input", { bubbles: true }));
      }
      this._updateStickyQty(qty);
    }

    _updateStickyQty(qty) {
      if (!qty) return;
      document.querySelectorAll("[data-sticky-quantity]").forEach((input) => {
        input.value = qty;
      });
    }

    _updatePrices(priceCents) {
      if (!priceCents) return;

      if (this.singlePriceEl)
        this.singlePriceEl.textContent = this._formatMoney(priceCents);

      this.bundleTiers.forEach((tier) => {
        if (tier.promo) this._renderTier(tier);
      });

      this._syncMainPrice(priceCents);
    }

    _tierBundlePriceCents(tier, unitPrice) {
      const promo = tier.promo;
      if (!promo || !unitPrice) return 0;
      return this._promoType(promo) === "percent"
        ? this._totalPriceCents(promo)
        : unitPrice * this._buyQty(promo);
    }
    _tierHasRequiredAddonProducts(tier) {
  // Tiers with no addon-products key have no such requirement.
  if (!tier.addonProducts) return true;
  const items = tier.addonProducts[String(this.currentVariantId())];
  return Array.isArray(items) && items.length > 0;
}

    _tierUnitDisplayPriceCents(tier, unitPrice) {
      const promo = tier.promo;
      if (!promo || !unitPrice) return 0;
      return this._promoType(promo) === "percent"
        ? unitPrice * this._bundleQty(promo)
        : unitPrice;
    }

    _addonPriceCents(tier) {
      return parseInt(tier?.addonCheckbox?.dataset.addonPriceCents, 10) || 0;
    }

    _selectedMainPriceCents(priceCents = this.currentVariant?.price) {
      if (!priceCents) return 0;
      const tier = this.selectedTier;
      const promo = tier?.promo;
      if (!promo) return priceCents;

      let total = this._tierBundlePriceCents(tier, priceCents);
      if (tier.addonCheckbox?.checked) {
        total += this._addonPriceCents(tier);
      }
      return total;
    }

    _setMainPriceText(mainPriceEl, formattedPrice) {
      if (!mainPriceEl || !formattedPrice) return;

      mainPriceEl
        .querySelectorAll(
          ".price__regular .price-item--regular, .price__sale .price-item--sale",
        )
        .forEach((amountEl) => {
          const innerPriceEl = amountEl.querySelector("span") || amountEl;
          innerPriceEl.textContent = formattedPrice;
        });
    }

    _setStickyButtonPriceText(formattedPrice) {
      if (!formattedPrice) return;
      document.querySelectorAll("[data-sticky-button-price]").forEach((el) => {
        el.textContent = formattedPrice;
      });
    }

    _atcQty() {
      const qty = parseInt(this.qtyInput?.value, 10);
      return qty > 0 ? qty : 1;
    }

    // Cart total for what the button would add: whole promo sets are charged at
    // the set price, any leftover units at the plain unit price. With no tier
    // selected, the set is a single unit, so this reduces to price x quantity.
    _atcTotalPriceCents(priceCents = this.currentVariant?.price) {
      const unitPrice = priceCents || 0;
      if (!unitPrice) return 0;

      const promo = this.selectedTier?.promo;
      const isBundle = !!promo;
      const setQty = isBundle ? Math.max(this._bundleQty(promo), 1) : 1;
      const setPrice = isBundle
        ? this._selectedMainPriceCents(unitPrice)
        : unitPrice;

      const qty = this._atcQty();
      const sets = Math.floor(qty / setQty);
      return sets * setPrice + (qty - sets * setQty) * unitPrice;
    }

    _syncAtcButtonPrice(priceCents = this.currentVariant?.price) {
      const totalCents = this._atcTotalPriceCents(priceCents);
      if (!totalCents) return;

      const formattedPrice = this._formatMoneyWithoutTrailingZeros(totalCents);
      const scope = this.form || document;

      scope.querySelectorAll("[data-price-template]").forEach((labelEl) => {
        const template = labelEl.dataset.priceTemplate;
        if (!template) return;

        const label = template.replace("[[price]]", () => formattedPrice);
        // global.js toggleAddButton() restores the label from data-label after
        // every variant fetch, so keep it in sync or the price snaps back.
        labelEl.dataset.label = label;
        // A disabled button reads "Sold out"/"Unavailable" — leave it alone.
        if (!labelEl.closest("button")?.hasAttribute("disabled")) {
          labelEl.textContent = label;
        }
      });
    }

    _queueMainPriceSync(priceCents = this.currentVariant?.price) {
      window.requestAnimationFrame?.(() => {
        this._syncMainPrice(priceCents);
      });

      window.setTimeout(() => {
        this._syncMainPrice(priceCents);
      }, 100);
    }

    _selectedCardPriceText() {
      const priceEl = this.selectedTier
        ? this.selectedTier.priceEl
        : this.singlePriceEl;
      return priceEl?.textContent?.trim() || "";
    }

    _syncMainPrice(priceCents = this.currentVariant?.price) {
      const priceEl = this._findMainPriceEl();
      const fallbackPrice = this._selectedMainPriceCents(priceCents);
      const priceText =
        this._selectedCardPriceText() ||
        (fallbackPrice ? this._formatMoney(fallbackPrice) : "");

      this._setMainPriceText(priceEl, priceText);
      this._setStickyButtonPriceText(priceText);
      this._syncAtcButtonPrice(priceCents);
    }

    _formatMoney(cents) {
      const amount = cents / 100;
      return this.moneyFormat
        .replace("{{amount}}", amount.toFixed(2))
        .replace("{{amount_no_decimals}}", Math.floor(amount))
        .replace(
          "{{amount_with_comma_separator}}",
          amount.toFixed(2).replace(".", ","),
        );
    }

    // Mirrors Liquid's money_without_trailing_zeros, which renders the button's
    // initial label — otherwise "RM120" flips to "RM120.00" on first sync.
    _formatMoneyWithoutTrailingZeros(cents) {
      return this._formatMoney(cents).replace(/([.,])00(?!\d)/, "");
    }

    _formatPercent(value) {
      const percent = Number(value);
      if (!Number.isFinite(percent)) return "0";
      return percent.toFixed(2).replace(/\.?0+$/, "");
    }

    _promoType(promo) {
      const value = String(promo?.promoType || "")
        .trim()
        .toLowerCase();
      return value === "percent" ? "percent" : "buy_x_free_y";
    }

    _savingsDisplay(promo) {
      const value = String(promo?.savingsDisplay || "")
        .trim()
        .toLowerCase();
      return value === "amount" || value === "rm" ? "amount" : "percent";
    }

    currentVariantId() {
      return this.currentVariant?.id || "";
    }

    _productTitle() {
      return this.el.dataset.productTitle || "";
    }

    _buyQty(promo) {
      return Math.max(parseInt(promo?.buyQty, 10) || 1, 1);
    }

    _freeQty(promo) {
      return Math.max(parseInt(promo?.freeQty, 10) || 0, 0);
    }

    _totalPriceCents(promo) {
      const value = String(promo?.totalPrice ?? "").replace(",", ".");
      return Math.round(Math.max(parseFloat(value) || 0, 0) * 100);
    }

    _bundleQty(promo) {
      return this._promoType(promo) === "percent"
        ? this._buyQty(promo)
        : this._buyQty(promo) + this._freeQty(promo);
    }

    _bundlePaidDisplayQty(promo) {
      return this._promoType(promo) === "percent"
        ? this._bundleQty(promo)
        : this._buyQty(promo);
    }

    _savePct(promo, unitPrice) {
      if (this._promoType(promo) === "percent") {
        const originalTotal = this._originalTotalCents(promo, unitPrice);
        const savings = this._savingsCents(promo, unitPrice);
        if (!originalTotal || !savings) return 0;
        return (savings / originalTotal) * 100;
      }
      const totalQty = this._bundleQty(promo);
      if (!totalQty) return 0;
      return Math.round((this._freeQty(promo) / totalQty) * 100);
    }

    _saveLabel(promo, unitPrice) {
      if (this._savingsDisplay(promo) === "amount") {
        const savings = this._savingsCents(promo, unitPrice);
        return savings ? `- Save ${this._formatMoney(savings)}` : "";
      }

      const savePct = this._savePct(promo, unitPrice);
      return savePct ? `- Save ${this._formatPercent(savePct)}%` : "";
    }

    _originalTotalCents(promo, unitPrice) {
      return (unitPrice || 0) * this._bundleQty(promo);
    }

    _savingsCents(promo, unitPrice) {
      if (!unitPrice) return 0;

      if (this._promoType(promo) === "percent") {
        return Math.max(
          this._originalTotalCents(promo, unitPrice) -
            this._totalPriceCents(promo),
          0,
        );
      }

      return unitPrice * this._freeQty(promo);
    }
  }

  function init() {
    document.querySelectorAll(".bundle-picker").forEach((el) => {
      if (!el._bundlePicker) el._bundlePicker = new BundlePicker(el);
    });
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();

  document.addEventListener("shopify:block:select", init);
  document.addEventListener("shopify:section:load", init);
})();
